import React from "react";
import "./ChartLegend.scss";

// Leyenda de cuadraditos de color + etiqueta, para usar al lado de una
// dona/torta en vez de pills debajo. `items`: [{ color, label }].
export function ChartLegend({ items }) {
  return (
    <div className="chart-legend">
      {items.map((it) => (
        <div key={it.label} className="chart-legend__item">
          <span className="chart-legend__swatch" style={{ backgroundColor: it.color }} />
          {it.label}
        </div>
      ))}
    </div>
  );
}
